export enum RecountMode {
  Both = 'both',
  QtyInNfe = 'qty_in_nfe',
  QtySeparate = 'qty_separate'
}

export enum DamageRecordMode {
  Both = 'both',
  QtyInNfe = 'qty_in_nfe',
  QtySeparate = 'qty_separate'
}

export interface StockRecountERPSettings {
    isRestrictEntryNfe: boolean
    isPartialEntryNfe: boolean
    canEditRecountedItem: boolean
    limitBarcodeLength: number
    showNfeProductAmount: boolean
    recountMode: RecountMode
    damageRecordMode: DamageRecordMode
}

export interface StockERPSettings {
  allowNegativeStock?: boolean
  showNegativeWarning?: boolean
  allowProductValueChanges?: boolean
  prioritizeMovementCost?: boolean
  recountSettings?: StockRecountERPSettings
}
